import ReactMarkdown from "react-markdown";

export default function Message({ role, content, streaming = false }) {
  return (
    <div className={`message message-${role}`}>
      <div className="message-bubble">
        {role === "assistant" ? (
          <ReactMarkdown>{content || ""}</ReactMarkdown>
        ) : (
          <p>{content}</p>
        )}
        {streaming && !content && (
          <div className="typing-indicator">
            <span /><span /><span />
          </div>
        )}
      </div>
    </div>
  );
}
